/**
 * The Suspense fallback for the thread chunk.
 *
 * It has to be exactly the pane's height. The pane opens by measuring the
 * composer before and after and scrolling the page by the difference; a
 * fallback of a different height would compensate for the wrong number and then
 * jump again when the real thread swapped in.
 */

import { Loader2 } from 'lucide-react'

export function AskProfilePaneSkeleton() {
  return (
    <div className="flex h-full flex-col justify-end p-3.5">
      <div className="flex items-center gap-2 text-[12.5px] text-muted-foreground">
        <Loader2 className="size-3 animate-spin text-primary" aria-hidden />
        <span>Opening…</span>
      </div>
    </div>
  )
}
